import React, { useState } from "react";
import * as R from "ramda";

import { useDispatch } from "react-redux";

import PropTypes from "prop-types";
import { Button, Label, Input, Form, Row } from "reactstrap";

import generateAction from "../../../../utils/action-helpers";

import { USER } from "../../../../state/actions";

const AddEditForm = ({ close, isEditing, index, editingObject, users }) => {
  const [id, setId] = useState(isEditing ? editingObject.id : "");
  const [role, setRole] = useState(isEditing ? editingObject.role : "");
  const dispatch = useDispatch();

  const submit = () => {
    dispatch(
      generateAction(isEditing ? USER.EDIT : USER.ADD, {
        user: { id, role },
        users,
        index
      })
    );
    close();
  };

  const submitActive =
    !R.isEmpty(id) && (role !== "Admin" || role !== "Editor" || role !== "Viewer");

  return (
    <div className="detail-form sidebar-content">
      <div className="sidebar-header">
        <h5 className="sidebar-title">
          {isEditing ? "Edición de usuario" : "Creación de usuario"}
        </h5>
        <button type="button" className="close" aria-label="Close" onClick={close}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="sidebar-body form-group-info">
        <Form>
          {/* Transfer data */}
          <Row>
            <div className="col-12">
              <h4>Datos de usuario</h4>
            </div>
            <div className="col-12">
              <Row className="mb-3">
                <div className="col-md-12">
                  <Label>ID usuario windows</Label>
                  <Input
                    type="text"
                    value={id}
                    onChange={event => setId(event.target.value)}
                    disabled={isEditing}
                  />
                </div>
                <div className="col-12 mb-3">
                  <Label for="selRole">Rol</Label>
                  <select
                    name="selRole"
                    id="selRole"
                    className="form-control"
                    onChange={event => setRole(event.target.value)}
                  >
                    <option value="" selected={role === ""}>
                      Selecciona una opción
                    </option>
                    <option value="Admin" selected={role === "Admin"}>
                      Admin
                    </option>
                    <option value="Editor" selected={role === "Editor"}>
                      Editor
                    </option>
                    <option value="Viewer" selected={role === "Viewer"}>
                      Viewer
                    </option>
                  </select>
                </div>
              </Row>
            </div>
          </Row>
        </Form>
      </div>
      <div className="sidebar-footer">
        <Button color="secondary" onClick={close}>
          Cancelar
        </Button>
        <Button type="submit" onClick={submit} color="primary" disabled={!submitActive}>
          {isEditing ? "Modificar" : "Añadir"}
        </Button>
      </div>
    </div>
  );
};

AddEditForm.propTypes = {
  close: PropTypes.func,
  isEditing: PropTypes.bool,
  index: PropTypes.number,
  editingObject: PropTypes.shape({
    id: PropTypes.number,
    role: PropTypes.string
  }),
  users: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, role: PropTypes.string }))
};

AddEditForm.defaultProps = {
  close: () => {},
  isEditing: false,
  index: -1,
  editingObject: {},
  users: []
};

export default AddEditForm;
